import createSeededNoise3D from "../../createSeededNoise3D"

export const globalNoise3D100 = createSeededNoise3D(100)
